(function () {
  'use strict';

  var page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  var grid = page.querySelector('[data-wishlist-grid]');
  var empty = page.querySelector('[data-wishlist-empty]');
  var status = page.querySelector('[data-wishlist-status]');
  var rootUrl = page.getAttribute('data-root-url') || '/';
  var currency = page.getAttribute('data-currency') || 'INR';
  var locale = page.getAttribute('data-locale') || 'en-IN';
  var renderToken = 0;

  function productUrl(handle) {
    return rootUrl + 'products/' + encodeURIComponent(handle);
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return currency + ' ' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function buildCard(product, handle) {
    var card = element('article', 'wishlist-page__card');
    var media = element('div', 'wishlist-page__media');
    var imageLink = element('a', 'wishlist-page__image');
    imageLink.href = productUrl(handle);
    imageLink.setAttribute('aria-label', 'View ' + (product.title || handle));

    if (product.featured_image) {
      var image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.width = 600;
      image.height = 600;
      imageLink.appendChild(image);
    } else {
      imageLink.appendChild(element('span', 'wishlist-page__image-placeholder', 'No image'));
    }

    var remove = element('button', 'wishlist-page__remove');
    remove.type = 'button';
    remove.setAttribute('data-wishlist-remove', handle);
    remove.setAttribute('aria-label', 'Remove ' + (product.title || handle) + ' from wishlist');
    remove.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" />' +
      '</svg>';

    media.appendChild(imageLink);
    media.appendChild(remove);

    var title = element('h2', 'wishlist-page__title');
    var titleLink = element('a', '', product.title || handle);
    titleLink.href = productUrl(handle);
    title.appendChild(titleLink);

    var meta = element('p', 'wishlist-page__meta');
    var price = element('span', 'wishlist-page__price', formatMoney(product.price));
    var availability = element(
      'span',
      'wishlist-page__availability',
      product.available ? ' · In stock' : ' · Sold out'
    );
    meta.appendChild(price);
    meta.appendChild(availability);

    var actions = element('div', 'wishlist-page__actions');
    var availableVariant = Array.isArray(product.variants)
      ? product.variants.find(function (variant) {
          return variant.available;
        })
      : null;
    var addToCart = element(
      'button',
      'button wishlist-page__add',
      availableVariant ? 'Add to cart' : 'Sold out'
    );
    addToCart.type = 'button';
    addToCart.disabled = !availableVariant;
    if (availableVariant) {
      addToCart.setAttribute('data-wishlist-add-to-cart', String(availableVariant.id));
      addToCart.setAttribute('data-default-label', 'Add to cart');
      addToCart.setAttribute('aria-label', 'Add ' + (product.title || handle) + ' to cart');
    }
    var actionStatus = element('span', 'wishlist-page__action-status');
    actionStatus.setAttribute('data-wishlist-action-status', '');
    actionStatus.setAttribute('role', 'status');
    actions.appendChild(addToCart);
    actions.appendChild(actionStatus);

    card.appendChild(media);
    card.appendChild(title);
    card.appendChild(meta);
    card.appendChild(actions);
    return card;
  }

  function fetchProduct(handle) {
    return fetch(productUrl(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (response.status === 404) return { handle: handle, missing: true };
      if (!response.ok) throw new Error('Unable to load ' + handle);
      return response.json().then(function (product) {
        return { handle: handle, product: product };
      });
    });
  }

  function showEmpty() {
    status.hidden = true;
    grid.innerHTML = '';
    empty.hidden = false;
  }

  function render(items) {
    var token = ++renderToken;
    var wishlist = window.MRJewelsWishlist;
    if (!wishlist) return;
    var currentItems = Array.isArray(items) ? items : wishlist.read();

    grid.innerHTML = '';
    empty.hidden = true;

    if (!currentItems.length) {
      showEmpty();
      return;
    }

    status.hidden = false;
    status.textContent = 'Loading your wishlist…';

    Promise.allSettled(
      currentItems.map(function (item) {
        return fetchProduct(item.handle);
      })
    ).then(function (results) {
      if (token !== renderToken) return;

      var missingHandles = [];
      var loadedCount = 0;
      var failedCount = 0;
      grid.innerHTML = '';

      results.forEach(function (result) {
        if (result.status === 'rejected') {
          failedCount += 1;
          return;
        }
        if (result.value.missing) {
          missingHandles.push(result.value.handle);
          return;
        }
        grid.appendChild(buildCard(result.value.product, result.value.handle));
        loadedCount += 1;
      });

      status.hidden = true;
      if (!loadedCount && !failedCount) showEmpty();
      if (failedCount) {
        status.hidden = false;
        status.textContent = 'Some wishlist items could not be loaded. Please try again.';
      }

      if (missingHandles.length) {
        wishlist.write(
          wishlist.read().filter(function (item) {
            return missingHandles.indexOf(item.handle) === -1;
          })
        );
      }
    });
  }

  page.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton && window.MRJewelsWishlist) {
      window.MRJewelsWishlist.remove(removeButton.getAttribute('data-wishlist-remove'));
      return;
    }

    var addButton = event.target.closest('[data-wishlist-add-to-cart]');
    if (!addButton || addButton.disabled) return;

    var variantId = Number(addButton.getAttribute('data-wishlist-add-to-cart'));
    var defaultLabel = addButton.getAttribute('data-default-label') || 'Add to cart';
    var actionStatus = addButton.parentElement.querySelector('[data-wishlist-action-status]');
    addButton.disabled = true;
    addButton.classList.add('is-loading');
    addButton.textContent = 'Adding…';
    if (actionStatus) actionStatus.textContent = '';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().then(function (error) {
          throw new Error(error.description || 'Unable to add this product.');
        });
      })
      .then(function () {
        return fetch(rootUrl + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh the cart.');
        return response.json();
      })
      .then(function (cart) {
        if (typeof window.buildCart === 'function') {
          window.buildCart(cart, true, addButton);
        } else {
          document.querySelectorAll('[data-cart-count]').forEach(function (count) {
            count.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
            count.style.display = cart.item_count ? 'flex' : 'none';
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        addButton.textContent = 'Added';
        if (actionStatus) actionStatus.textContent = 'Product added to cart.';
      })
      .catch(function (error) {
        addButton.textContent = 'Try again';
        if (actionStatus) actionStatus.textContent = error.message;
      })
      .finally(function () {
        addButton.classList.remove('is-loading');
        window.setTimeout(function () {
          addButton.disabled = false;
          addButton.textContent = defaultLabel;
          if (actionStatus) actionStatus.textContent = '';
        }, 1400);
      });
  });

  document.addEventListener('mrjewels:wishlist:change', function (event) {
    render(event.detail && event.detail.items);
  });

  document.addEventListener('mrjewels:wishlist:external-change', function (event) {
    render(event.detail && event.detail.items);
  });

  function init() {
    if (!window.MRJewelsWishlist) {
      window.setTimeout(init, 25);
      return;
    }
    render();
  }

  init();
})();
